import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/views/LoginPage.vue";
import DashboardPage from "@/views/DashboardPage.vue";
import UsersPage from "@/views/UsersPage.vue";
import TransactionPage from "@/views/TransactionPage.vue";
import TransactionDetail from "@/views/TransactionDetail.vue";
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: LoginPage },
  { path: "/dashboard", component: DashboardPage, meta: { requiresAuth: true } },
  { path: "/users", component: UsersPage, meta: { requiresAuth: true } },
  { path: "/transaction", component: TransactionPage, meta: { requiresAuth: true } },
  { path: "/transaction/:id", component: TransactionDetail, meta: { requiresAuth: true } },
  { path: "/privacy-policy", component: PrivacyPolicyPage }, // Public route - no auth required
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const isAuthenticated = !!localStorage.getItem("user"); // Contoh sederhana, sesuaikan dengan sistem autentikasi kamu
  
//   if (to.meta.requiresAuth && !isAuthenticated) {
//     next("/login"); // Redirect ke login jika belum login
//   } else {
//     next(); // Lanjutkan ke halaman yang diminta
//   }
// });

export default router;
